module.exports = __webpack_public_path__ + "media/hyper/images/payments/master-4ed494618fc2b5d148ae749b59f43723.png";